/* eslint-disable */
import * as React from 'react';
import './UsageBlock.scss'

const UsageBlock = ({ children: children, usageType}) => {

    const usageDo = require('@images/usage/usgDo.svg'); 
    const usageDont = require('@images/usage/usgDont.svg'); 
    const usageCaution = require('@images/usage/usgCaution.svg'); 
   
    let className = 'usgblk ';
    let usgIcon = ''
    if (usageType === "Do" || usageType === "Correct")
    {
        className += 'usgdo';
        usgIcon = usageDo;
    }
    else if (usageType === "Don't" || usageType === "Incorrect" || usageType === "Wrong")
    {
        className += 'usgdnt';
        usgIcon = usageDont;
    }
    else if (usageType === "Caution")
    {
        className += ' usgctn';
        usgIcon = usageCaution;
    }
    
        return (
            <div className={className}>
                <div className="usgTitle"> <img src={usgIcon} alt="Usage Icon"/> {usageType}</div>
                <div className="usgCnt">
                    {children}
                </div>
            </div>
        )
    };
     
export default UsageBlock;







